import { InlineAlertAnimator, TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';
import { LinkedTaskDeleteButton } from './LinkedTaskDeleteButton';
import { LinkedTaskEditButton } from './LinkedTaskEditButton';

const numberWidth = 40;

export type LinkedTaskItemProps = {
  number: number;
  title: string;
  content?: React.ReactNode;
  buttonType?: 'edit' | 'view' | 'delete';
  expansionContent?: React.ReactNode;
  onDelete?: () => void;
}

const wrapperStyle = style({
  display: 'flex',
  alignItems: 'center',
});

const innerWrapperStyle = style({
  padding: `${TabStyles.Spacing.SmallSpace}px`,
  border: `1px solid ${TabStyles.Colors.L6}`,
  flex: '1 1 auto',
  display: 'flex',
});

export const numberStyle = style({
  width: numberWidth,
  textAlign: 'center',
  flex: '0 0 auto',
});

const titleStyle = style({
  margin: `0 ${TabStyles.Spacing.DefaultSpace}px`,
});

const contentStyle = style({
  margin: `0 ${TabStyles.Spacing.DefaultSpace}px`,
  flex: '1 1 auto',
});

const expandoStyle = style({
  padding: `${TabStyles.Spacing.DefaultSpace}px`,
  border:  `1px solid ${TabStyles.Colors.L6}`,
  marginLeft: numberWidth,
  marginTop: -1,
});

export function LinkedTaskItem(props: LinkedTaskItemProps): JSX.Element {
  const [isExpanded, setIsExpanded] = React.useState(false);

  function renderButton() {
    switch(props.buttonType) {
      case 'edit':
        return <LinkedTaskEditButton isExpanded={isExpanded} setIsExpanded={setIsExpanded}/>;
      case 'delete':
        return <LinkedTaskDeleteButton onDelete={props.onDelete}/>;
      default:
        // default type 'view'
        return;
    }
  }

  return (
    <div>
      <div className={wrapperStyle}>
        <div className={numberStyle}>{props.number + 1}</div>
        { props.content ? props.content :
          <div className={innerWrapperStyle}>
            <div className={titleStyle}>{props.title}</div>
            <span className={contentStyle}>{props.content}</span>
          </div>
        }
        {renderButton()}
      </div>
      <InlineAlertAnimator>
        {isExpanded && props.expansionContent &&
          <div className={expandoStyle}>
            {props.expansionContent}
          </div>
        }
      </InlineAlertAnimator>
    </div>
  );
}
